export default {
    state: () => ({
        dataForm: {
            phone: "",
            email: "",
            lname: "",
            password: "",
            remember: "",
        },
        phoneCode: "",
        method: ''
    }),
    getters: {
        getMethodOfLogin: (state) => {
            return state.method
        },
        getDataForm: (state) => {
            return state.dataForm;
        },
        getPhoneCode: (state) => {
            return state.phoneCode;
        },
        isEmailFilled: (state) => {
            return state.dataForm.email !== "";
        },
    },
    mutations: {
        setMethodOfLogin(state, data) {
            state.method = data;
        },
        setDataForm(state, data) {
            state.dataForm = data;
        },
        setPhoneCode(state, data) {
            state.phoneCode = data;
        },
    },
    actions: {
        updateDataForm({commit}, data) {
            commit("setDataForm", data);
        },
        updatePhoneCode({commit}, data) {
            commit("setPhoneCode", data);
        },
    },
    namespaced: true,
};
